import { useStateContext } from "../../context/ContextProvider";
import { cn } from "../../lib/utils";


export const BentoGrid = ({
  className,
  children
}) => {
  const {currentLang} =useStateContext()
  const HightSize =currentLang==="ar" ?" md:auto-rows-[14rem]" :" md:auto-rows-[18rem]"
  return (
    <div
      className={cn(
        "mx-auto grid max-w-7xl grid-cols-1 gap-4 currentLang  md:grid-cols-3",
        className,HightSize
      )}>
      {children}
    </div>
  );
};

export const BentoGridItem = ({
  className,
  title,
  description,
  image,
  subtitle,
  id
}) => {
  const cardStyle3="bg-gradient-to-b from-light-blueGlass1 via-light-blueGlass1  via-light-blueGlass1  to-light-blueGlass2 border border-light-blueGlass2"
  const cardStyle4="bg-gradient-to-b from-light-orangeGlass1 via-light-orangeGlass1 to-light-orangeGlass2 border border-light-orangeGlass2"
    const Style = id ===3 ?cardStyle3 :id===4?cardStyle4:"bg-gradient-to-b from-light-glass1 to-light-glass2 dark:from-dark-glass1 dark:to-dark-glass2 border border-light-glassStrock2  dark:border-dark-glassStrock1 ";
    const {currentLang}=useStateContext()
    const isAr =currentLang==="ar"
  return (
    <div
      className={cn(
        "group/bento shadow-input row-span-1 flex flex-col justify-between space-y-4 rounded-xl  backdrop-blur-sm p-2 transition duration-200 hover:shadow-xl dark:border-white/[0.2] dark:shadow-none min-h-40",
        className,
        Style
      )}>
      

      {id === 1 ? (
        <div className="transition   flex flex-col md:flex-row h-full gap-4 duration-200 group-hover/bento:translate-x-2">
          <div className="md:w-3/5 w-full h-48 md:h-full rounded-lg overflow-hidden">
            <img src={image} className="w-full h-full object-cover rounded-lg" alt={title} />
          </div>
          <div className="flex flex-col py-4 md:w-2/5">
            <div className="mb-4">
              <h4 className="h5 mb-1 text-light-title dark:text-dark-title">
                {title}
              </h4>
              {subtitle && (
                <h6 className="h6 text-light-subtitle dark:text-dark-subtitle mt-1">
                  {subtitle}
                </h6>
              )}
                 <div className={`border border-b-1 ${isAr ? "mt-2" :""} border-light-strock`}></div>
            </div>
            <div className={`body-2 overflow-y-auto text-neutral-600 dark:text-neutral-300 flex-grow`}>
              {description}
            </div>
           
            
          </div>
        </div>
      ) : id ===2 ?(
        <div className="transition flex flex-col  h-full gap-4 duration-200 group-hover/bento:translate-x-2">
        <div className="md:h-1/2   w-full h-48 md:w-full rounded-lg overflow-hidden">
          <img src={image} className="w-full h-full object-cover bg-center  rounded-lg" alt={title} />
        </div>
      
        <div className="flex flex-col md:h-1/2">
          <div className="">
            <h4 className="h5 text-light-title dark:text-dark-title">
              {title}
            </h4>
            {subtitle && (
              <h6 className="h6 text-light-subtitle dark:text-dark-subtitle ">
                {subtitle}
              </h6>
            )}
          </div>
          <div className="border border-b-1 my-2 border-light-strock"></div>
          <div className="body-3 overflow-y-auto text-neutral-600 dark:text-neutral-300 flex-grow">
            {description}
          </div>
        </div>
      </div>
      ):id === 3 ? (

        <div className="transition flex flex-col md:flex-row h-full gap-2 duration-200 group-hover/bento:translate-x-2">
          <div className="md:w-2/5 w-full h-48 md:h-full rounded-lg overflow-hidden">
            <img src={image} className="w-full h-full object-cover rounded-lg" alt={title} />
          </div>
          <div className="flex flex-col md:w-3/5">
            <div className="mb-4">
              <h4 className="h5 text-light-title dark:text-dark-title">
                {title}
              </h4>
              {subtitle && (
                <h6 className="h6 text-light-subtitle dark:text-dark-subtitle mt-1">
                  {subtitle}
                </h6>
              )}
            </div>
            <div className="body-3 overflow-y-auto  flex-grow">
              {description}
            </div>
            
            
          </div>
        </div>
      ):(
        <div className="transition flex flex-col md:flex-row h-full gap-2 duration-200 group-hover/bento:translate-x-2">
        <div className="md:w-2/5 w-full h-48 md:h-full rounded-lg overflow-hidden">
          <img src={image} className="w-full h-full object-cover rounded-lg" alt={title} />
        </div>
        <div className="flex flex-col md:w-3/5">
          <div className="mb-4">
            <h4 className="h5 text-light-title dark:text-dark-title">
              {title}
            </h4>
            {subtitle && (
              <h6 className="h6 text-light-subtitle dark:text-dark-subtitle mt-1">
                {subtitle}
              </h6>
            )}
          </div>
          <div className="body-3  overflow-y-auto flex-grow">
          {description}
          </div>
          
          
        </div>
      </div>
      )}
    </div>
  );
};